/* global SgTrackingCore, jQuery, window */
import TaggedLogger from '../common/debug/tagged-logger';
import BranchIo from '../common/branch-io/BranchIo';
import SGLink from '../common/shopgate-link';

const logger = new TaggedLogger('ShopgateOpenApp', 'color: SeaGreen;');

(function ($) {
  /**
   * The following lines are taken from https://gist.github.com/zengfenfei/51b36c008faaea4cb934
   * They are here to suppress the invalid address warning the safari
   * might give when we try to open the app from it
   */
  let openAppProxyFrame;

  /**
   * Opens by proxy frame
   * @return {*}
   */
  function getOpenAppProxyFrame() {
    if (openAppProxyFrame) {
      return openAppProxyFrame;
    }
    openAppProxyFrame = document.createElement('iframe');
    document.body.appendChild(openAppProxyFrame);
    openAppProxyFrame.style.display = 'none';
    return openAppProxyFrame;
  }

  /**
   * Problems
   * `window.open` will open tab selection view of iOS Safari
   * @param {string} url - url
   */
  function openAppByFrame(url) {
    const frm = getOpenAppProxyFrame();
    const src = `<script>window.location="${url}";</script>`;
    frm.contentDocument.write(src);
  }

  /**
   * Open native app through iframe so that mobile safari
   * "invalid address" warnings be suppressed when the app is not installed.
   * `window.location=url` will not open native app in the iframe of android chrome
   * Android will go to the next page even if the url scheme is not supported
   * @param {string} url - url
   */
  function openApp(url) {
    if (
      window.chrome
      && window.navigator.userAgent.search(/\bChrome\b/) !== -1
    ) {
      window.location = url;
    } else {
      openAppByFrame(url);
    }
  }

  /*
   * End from https://gist.github.com/zengfenfei/51b36c008faaea4cb934
   */

  /**
   * Opens link in legacy mode
   * @param {object} options - options
   */
  function openByOurOwn(options) {
    if (options.os === 'ios') {
      /*
       If we are on an ios device try to open the app
       when the app is not available we open the store after a short timeout
       */
      setTimeout(() => {
        window.location = options.storeUrl;
      }, 300);
      openApp(options.appUrl);
    } else {
      // If we are on an android device just open the store url
      window.location = options.storeUrl;
    }
  }

  /**
   * This plugin decides according to the operation system of
   * the device either to open the installed app directly
   * or to go to the store for download
   *
   * storeUrl: url to open the store
   * appUrl: url to open the app
   * os: operating system of device
   * cookieLifetime: lifetime of cookie in days
   *
   * @param {object} incomingOptions - options
   */

  $.fn.shopgateOpenApp = function (incomingOptions) {
    logger.info('Starts.');
    const defaults = {
      storeUrl: '',
      appUrl: '',
      os: 'android',
      cookieLifetime: 60,
      branchIoKey: null,
    };

    let options = incomingOptions || {};
    options = $.extend({}, defaults, options);
    let branchSdk;
    if (options.branchIoKey) {
      branchSdk = new BranchIo(options.branchIoKey);
    }
    const supportedOS = ['android', 'ios'];

    // Make sure we always have a number here
    options.cookieLifetime = parseInt(options.cookieLifetime, 10);

    if (
      options.storeUrl.length === 0
      && options.appUrl.length === 0
      && supportedOS.indexOf(options.os) === -1
      && options.cookieLifetime <= 0
    ) {
      logger.warn('Invalid options for the open app functionality - please check them again');
      return $();
    }

    return this.each(function () {
      const that = $(this);
      const parent = that.parent('.smartbanner');

      that.click((e) => {
        e.preventDefault();
        // Send open user interaction to tracker
        SgTrackingCore.track.smartbanner({
          eventAction: 'open',
          eventLabel: parent.data('location'),
        });

        if (branchSdk) {
          const link = new SGLink(window.location.pathname);
          link.setParams({
            utm_source: 'shopgate',
            utm_medium: 'branch-io-smartbanner',
            utm_campaign: parent.data('location'),
          });
          const data = {
            $deeplink_path: link.toString(),
            $always_deeplink: true,
          };

          branchSdk.sdk.link(
            {
              channel: 'mobileWebsite',
              data,
            },
            (err, branchLink) => {
              if (err) {
                openByOurOwn(options);
                logger.error('Could not get link. Fall back to legacy.', err);
                return;
              }
              window.location = branchLink;
            }
          );
        } else {
          openByOurOwn(options);
        }
      });
    });
  };
}(jQuery));



// WEBPACK FOOTER //
// ./Library/1.0/web/jquery.shopgate-open-app.js